// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React,{ createContext, useState } from "react";

export const EstadoIdContext = createContext()

export const EstadoIdContextProvider = ({children}) => {
    const [estadoIdContext, setEstadoIdContext] = useState('')

    return (
        <EstadoIdContext.Provider value={{estadoIdContext, setEstadoIdContext}}>
            { children }
        </EstadoIdContext.Provider>
    )
}